import { influencer } from '@round/api';
import { ExplorePlatform } from 'Modules/Plans/CreatorSearch/components/CreatorExploreTable/helpers';

/** Accepts a loading row, which the table renders as an empty object. */
export const getCreatorAccountId = (
    creator: influencer.CreatorSearchResult | {} | null | undefined,
    platform: ExplorePlatform | undefined
): number | undefined => {
    if (!creator || !('platforms' in creator) || !platform) {
        return undefined;
    }

    return creator.platforms?.[platform]?.[0]?.creatorbase_client_influencer_account_id;
};
